import React from "react";
import Draw3DMap from "./Draw3DMap";
import "./App.css";
import { LanguageProvider } from "./i18n";
import { UserProvider } from "./context/UserContext";

export default function App() {
  return (
    <LanguageProvider>
      <UserProvider>
        <div className="App">
          <Draw3DMap />
        </div>
      </UserProvider>
    </LanguageProvider>
  );
}